import React, { createContext, useState, useEffect } from 'react';
import axios from '../axios';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [auth, setAuth] = useState(null);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token) {
            setAuth(token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
    }, []);

    const login = async (email, password) => {
        try {
            const response = await axios.post('/login', { email, password });
            localStorage.setItem('token', response.data.token);
            setAuth(response.data.token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        } catch (error) {
            console.error('Login failed:', error);
        }
    };

    const register = async (name, email, password, password_confirmation) => {
        try {
            const response = await axios.post('/register', { name, email, password, password_confirmation });
            localStorage.setItem('token', response.data.token);
            setAuth(response.data.token);
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
        } catch (error) {
            console.error('Registration failed:', error);
        }
    };

    const logout = () => {
        localStorage.removeItem('token');
        setAuth(null);
        delete axios.defaults.headers.common['Authorization'];
    };

    const getUser = async () => {
        try {
            const response = await axios.get('/user');
            return response.data;
        } catch (error) {
            console.error('Failed to fetch user data:', error);
            return null;
        }
    };

    return (
        <AuthContext.Provider value={{ auth, login, register, logout, getUser }}>
            {children}
        </AuthContext.Provider>
    );
};
